import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=736bbc7b&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736bbc7b')) {
      api.createRecord('736bbc7b', component.options)
    } else {
      api.reload('736bbc7b', component.options)
    }
    module.hot.accept("./complete.vue?vue&type=template&id=736bbc7b&lang=pug&", function () {
      api.rerender('736bbc7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register_user/complete.vue"
export default component.exports